import gql from "graphql-tag";

export const MY_TIMESHEET_COSTS_SUBSCRIPTION = gql`
  subscription MySheetCostsSubscription {
    MySheetCostsSubscription
  }
`;
